import { Service } from '../config'
import { removePropertyEmpty } from '@/utils/index'

class PrecificationService extends Service {
  path = 'precificacao'

  async get(
    perPage: number,
    page: number,
    sortField: string = '',
    sortAscending: boolean = true,
    params: any
  ) {
    const payloadSubmitted = {
      ...params,
      PageSize: perPage,
      Page: page,
      SortField: sortField,
      SortAscending: sortAscending
    }

    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(payloadSubmitted)
    })

    return httpResponse
  }

  async getInpection(
    perPage: number,
    page: number,
    params?: any,
    sortField: string = '',
    sortAscending: boolean = true
  ) {
    let payloadSubmitted: any = {
      'Pagination.PageSize': perPage,
      'Pagination.Page': page,
      'Pagination.SortField': sortField,
      'Pagination.SortAscending': sortAscending
    }

    if (params) {
      payloadSubmitted = {
        'Pagination.PageSize': perPage,
        'Pagination.Page': page,
        'Pagination.SortField': sortField,
        'Pagination.SortAscending': sortAscending,
        ...params,
      }
    }

    const httpResponse = await this.httpClient.get(
      `${this.path}/obtervistorias`,
      {
        params: payloadSubmitted
      }
    )
    return httpResponse
  }

  async download(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async getCosts(params: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/obtercustospreparacao`,
      { params }
    )
    return httpResponse
  }

  async getGeneralCosts(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/obtercustos`, {
      params
    })
    return httpResponse
  }

  async getResumeOfAsset(params: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/obterresumoativo`,
      { params }
    )
    return httpResponse
  }

  async linkPrecification(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}?vistoriaId=${params}`
    )
    return httpResponse
  }

  async batchPrecification(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/precificarlote`,
      params
    )
    return httpResponse
  }

  async finish(payload: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/finalizar`,
      payload
    )
    return httpResponse
  }

  async update(payload: any) {
    const httpResponse = await this.httpClient.put(
      `${this.path}`,
      payload
    )
    return httpResponse
  }

  async cancel(payload: any) {
    const httpResponse = await this.httpClient.delete(`${this.path}/cancelar`, {
      data: payload
    })
    return httpResponse
  }
  async removeLink(payload: any) {
    const httpResponse = await this.httpClient.delete(`${this.path}`, {
      data: { precificacaoId: payload }
    })
    return httpResponse
  }

  async generalData() {
    const httpResponse = await this.httpClient.get(
      `${this.path}/obterdadosgerais`
    )
    return httpResponse
  }

  async getPrecificationHistory(precificationId: string) {
    const params = {
      precificacaoId: precificationId
    }
    const httpResponse = await this.httpClient.get(
      `${this.path}/obterValorHistorico`,
      { params }
    )
    return httpResponse
  }

  async getAcquisitionValue(plate: any) {
    const params = {
      placa: plate
    }
    const httpResponse = await this.httpClient.get(
      `${this.path}/obtervaloraquisicao`,
      { params }
    )
    return httpResponse
  }

  async getPurchaseValue(params : any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/obtervalorcompra`,
      { params }
    )
    return httpResponse
  }
}

export const precificationService = new PrecificationService()
